import React from 'react';

import SideMenu from '../../../components/SideMenu';
import Footer from '../../../components/Footer';
import Quotes from '../../../components/Quotes';
import { getTranslations } from '../../../services/languageUtils';

import TedTransfer from '../../../components/Transactions/Ted/Ted';
import TedLotTransfer from '../../../components/Transactions/Ted/TedLot';

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        type: 'tedTransfer',
        step: 0,
        valueBalance: 0.00,
        viewBalance: false,
        translations: {}
      };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  onChangeValue = event => {
    switch(event.target.name){
      case 'step':
        this.setState({step: event.target.value});
        break;

      default:
        break;
    }
  }
  render() {
    return (
     <section id="userPage" className="userPage transactionPage">
       <SideMenu />
 
       <div className="contentData">
         <div className="contentScroll">
         <Quotes />
         <p className="breadcrumb"><b><span  className="textPrimary">{this.state.translations.home} | {this.state.translations.transfers}</span> | {this.state.translations.ted}</b></p><br/>
         <p className="title"><span style={{fontWeight: "normal"}}>{this.state.translations.transfers} |</span> {this.state.translations.ted}</p><br/>
 
         <div className="contentSubData">
          <div className={"contentButtonPix " + (this.state.type==="tedTransfer"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "tedTransfer", step: 0})}}>
                         {
                           this.state.type==="tedTransfer" &&
                           <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                         }
                         {
                           this.state.type!=="tedTransfer" &&
                           <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                         }
                         Tranferência TED
                       </div>
          
                       {
                        <div className={"contentButtonPix " + (this.state.type==="batch"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "batch", step: 0})}}>
                            {
                              this.state.type==="batch" &&
                              <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                            }
                            {
                              this.state.type!=="batch" &&
                              <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                            }
                            {'TED em lote'}
                          </div>
            }

          {
            this.state.type !== "batch" &&
          <TedTransfer type={this.state.type} step={this.state.step} onChangeValue={this.onChangeValue} />
          }
          {
            this.state.type === "batch" &&
          <TedLotTransfer type={this.state.type} step={this.state.step} onChangeValue={this.onChangeValue} />
          }
         </div>
 
         <Footer />
         </div>
       </div>
     </section>
    );
   } 
 }

export default Item;
